export default "3.70.0";